import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
/**
 * Clase para definir funciones y propiedades de forma global, es decir, para ser utilizada en las demas clases
 */
@Injectable({
  providedIn: "root",
})
export class Setting {
  /**
   * Url de la API que utiliza la aplicacion para consultar las distintas inforamciones de los widgets
   */
  APIEndPoint: string = environment.APIEndPoint;
  BaseAPIUrl: string = this.APIEndPoint + "/api";

  /**
   * Nest API
   * */

  /**
   * Endpoints pre-definidos
   */
  Endpoint = {
    Login: `${this.APIEndPoint}users/login`,
    Users: `${this.BaseAPIUrl}/Users`,
    UserByAccess: `${this.BaseAPIUrl}/UserByAccess`,
    Prospects: `${this.BaseAPIUrl}/v1/Prospects`,
    CreateProspect: `${this.BaseAPIUrl}/v1/CreateProspects`,
    DelProspect: `${this.BaseAPIUrl}/v1/DelProspects`,
    FilterProspects: `${this.BaseAPIUrl}/v1/rest`,
    Views: `${this.BaseAPIUrl}/Views`,
    Roles: `${this.BaseAPIUrl}/Roles`,
    Access: `${this.BaseAPIUrl}/Access`,
    RemoveRoleAccess: `${this.BaseAPIUrl}/RemoveRoleAccess`,
    RolesAccess: `${this.BaseAPIUrl}/RolesAccess`,
    UsersRoles: `${this.BaseAPIUrl}/UsersRoles`,
    RemoveUserFromRole: `${this.BaseAPIUrl}/RemoveUserFromRole`,
    getPickList: `${this.APIEndPoint}/getPickList`,
    Logs: `${this.APIEndPoint}/api/Logs`,
    LogsByCompId: `${this.APIEndPoint}/LogsByCompId`,
    LogsUsers: `${this.APIEndPoint}/LogsUsers`,
    SalesForceObj: `${this.BaseAPIUrl}/v1/getObjectData`,
    getObjectDataMultiFilter: `${this.BaseAPIUrl}/v1/getObjectDataMultiFilter`,
  };

  /**
   * Endpoints pre-definidos para la API de Nest
   * relacionados a la conversion de leads a cuentas/programas
   * */

  /**
   * Global http options
   */
  HttpOptions = {
    headers: new HttpHeaders({
      // 'Content-Type': 'application/x-www-form-urlencoded'
    }),
  };
  /**
   * TimeOut general pre-definido
   */
  GlobalTimeOut: number = 30000;
}
